import React from "react";
import ComingSoon from "../../components/ComingSoon";

export default function LegalNotice() {
  return <ComingSoon title="Legal Notice" />;
}
